import { Action, createReducer, on } from '@ngrx/store';
import * as actions from 'src/app/recruiting/jobs/details/components/store/actions/job-details.actions';
import { JobDetails } from 'src/app/recruiting/jobs/details/models/job-details.model';
import { LoadingTypes } from 'src/app/shared/models/enums/loading.enum';

export interface JobDetailsState {
    job: JobDetails;
    loading: LoadingTypes;
    success: boolean;
}

const initialState: JobDetailsState = {
    job: undefined,
    loading: LoadingTypes.INIT,
    success: false
};

export function jobDetailsReducer(state: JobDetailsState, action: Action) {
    return createReducer(
        initialState,
        on(actions.loadJobDetails, (state, action) => ({
            ...state,
            loading: LoadingTypes.LOADING,
            success: false
        })),

        on(actions.loadJobDetailsSuccess, (state, action) => ({
            ...state,
            job: action.job,
            loading: LoadingTypes.LOADED,
            success: true
        })),

        on(actions.loadJobDetailsFailed, (state, action) => ({
            ...state,
            loading: LoadingTypes.LOADED,
            success: false
        }))
    )(state, action);
}

export function reducer(state: JobDetailsState | undefined, action: Action) {
    return jobDetailsReducer(state, action);
}
